export interface ModelCompanyprofile {
  id: string;
  status: string;
  name: string;
  registrationNumber: string;
  visitAddress?: {
    street: "";
    number: "";
    numberSuffix: "";
    postalCode: "";
    city: "";
    country: "";
  };
  phoneNumber: string;
  description: string;
  descriptionEn: string;
  descriptionDe: string;
  descriptionFr: string;
  descriptionPt: string;
  uniqueText: string;
  uniqueTextEn: string;
  uniqueTextDe: string;
  uniqueTextFr: string;
  uniqueTextPt: string;
  opportunitiesText: string;
  opportunitiesTextEn: string;
  opportunitiesTextDe: string;
  opportunitiesTextFr: string;
  opportunitiesTextPt: string;
  sectorId: string | null;
  sectorName: string;
  numberOfEmployees: string | null | number;
  websiteUri: string;
  twitterUri: string;
  facebookUri: string;
  linkedInUri: string;
  instagramUri: string;
  googleUri: string;
  avatarUri: string;
  coverPhotoUri: string;
  isCurrentUserFavorite: boolean;
  isCurrentUserConnected: boolean;
  companyImageReferences: any;
  areaOfInterests: any;
  educationLevels: any;
  regions: string | any;
  targetGroups: string[];
  currentUserMatchPercentage: number | string | null;
  primaryContact: {
    id: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    infix: string;
    phoneNumber: string;
    avatarUri: string;
  };
}

export const companyprofilePlaceholder = {
  avatarPlaceholder:
    "/assets/img/placeholder/image-placeholder-company-profile.jpg",
  avatarAccountPlaceholder:
    "/assets/img/placeholder/image-placeholder-profile.jpg",
};
